import { type ReactNode } from 'react'

import { Icon } from '@/components/icons/Icon'
import { type IconType } from '@/defs/icon'
import { cn } from '@/utils/commonUtil'

import styles from './IconWithLabel.module.scss'

type SizesType = 'xs' | 'sm' | 'lg'
type MarginSizesType = SizesType | 'none'

type Props = {
  children?: ReactNode
  iconAfter?: IconType | false
  iconAfterMargin?: MarginSizesType
  iconAfterSize?: SizesType
  iconBefore?: IconType | false
  iconBeforeMargin?: MarginSizesType
  iconBeforeSize?: SizesType
  inline?: boolean
  width?: 'full' | 'maxcontent'
  wrapNone?: boolean
}

export const IconWithLabel = ({
  children,
  iconAfter,
  iconAfterMargin,
  iconAfterSize,
  iconBefore,
  iconBeforeMargin,
  iconBeforeSize,
  inline,
  width,
  wrapNone,
}: Props) => (
  <span
    className={cn(styles.container, {
      hasIconAfter: !!iconAfter,
      hasIconBefore: !!iconBefore,
      iconAfterMargin,
      iconAfterSize,
      iconBeforeMargin,
      iconBeforeSize,
      inline,
      styles,
      width,
      wrapNone,
    })}
  >
    {iconBefore && (
      <span className={styles.iconBefore}>
        <Icon name={iconBefore} />
      </span>
    )}
    <span className={styles.label}>{children}</span>
    {iconAfter && (
      <span className={styles.iconAfter}>
        <Icon name={iconAfter} />
      </span>
    )}
  </span>
)
